import * as RatesActionTypes from '../actions/rates';

import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state = initialState.rates, action) => {
  const { payload, type } = action;

  switch (type) {
    case RatesActionTypes.SAVE_CUSTOM_PREMIUM_RATES:
    case RatesActionTypes.SAVE_CUSTOM_PREMIUM_RATES_PENDING:
      return { ...state, saveCustomRatesLoading: true };

    case RatesActionTypes.SAVE_CUSTOM_PREMIUM_RATES_REJECTED:
      return {
        ...state,
        saveCustomRatesLoading: false,
        ...errorResponseHandler(payload, 'SaveCustomRates')
      };

    case RatesActionTypes.SAVE_CUSTOM_PREMIUM_RATES_FULFILLED:
      return {
        ...state,
        success: payload.data.Info,
        saveCustomRatesLoading: false
      };

    case RatesActionTypes.FETCH_OTHER_RATES:
    case RatesActionTypes.FETCH_OTHER_RATES_PENDING:
      return { ...state, otherRatesLoading: true, otherRates: [] };

    case RatesActionTypes.FETCH_OTHER_RATES_REJECTED:
      return {
        ...state,
        otherRatesLoading: false,
        ...errorResponseHandler(payload, 'FetchOtherRates')
      };

    case RatesActionTypes.FETCH_OTHER_RATES_FULFILLED:
      return { ...state, otherRates: payload.data };

    case RatesActionTypes.FETCH_COMPARISON_OTHER_RATES:
    case RatesActionTypes.FETCH_COMPARISON_OTHER_RATES_PENDING:
      return {
        ...state,
        comparisonOtherRatesLoading: true,
        comparisonOtherRates: []
      };

    case RatesActionTypes.FETCH_COMPARISON_OTHER_RATES_REJECTED:
      return {
        ...state,
        comparisonOtherRatesLoading: false,
        ...errorResponseHandler(payload, 'FetchComparisonOtherRates')
      };

    case RatesActionTypes.FETCH_COMPARISON_OTHER_RATES_FULFILLED:
      return { ...state, comparisonOtherRates: payload.data };

    case RatesActionTypes.UPDATE_OTHER_RATES:
    case RatesActionTypes.UPDATE_OTHER_RATES_PENDING:
      return { ...state, updateRatesLoading: true, otherRate: {} };

    case RatesActionTypes.UPDATE_OTHER_RATES_REJECTED:
      return {
        ...state,
        updateRatesLoading: false,
        ...errorResponseHandler(payload, 'UpdateRates')
      };

    case RatesActionTypes.UPDATE_OTHER_RATES_FULFILLED:
      return {
        ...state,
        otherRate: payload.data,
        success: 'Succesful',
        updateRatesLoading: false
      };

    case RatesActionTypes.FETCH_STAMP_DUTY:
    case RatesActionTypes.FETCH_STAMP_DUTY_PENDING:
      return { ...state };

    case RatesActionTypes.FETCH_STAMP_DUTY_REJECTED:
      return {
        ...state,
        error: true,
        ...errorResponseHandler(payload, 'StampDuty')
      };

    case RatesActionTypes.FETCH_STAMP_DUTY_FULFILLED:
      return { ...state, stampDuty: payload.data };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/rates.js